module.exports = __webpack_public_path__ + "img/maiss.f95036d0.svg";